import React from 'react';
import { formatMoney, MONEY_UNIT } from '../utils/format';
import YoYBadge from './YoYBadge';
import './su-components.css';

export interface KpiPanel {
  label: string;
  /** Rupees. */
  sales: number | null | undefined;
  lySales: number | null | undefined;
  yoyPct: number | null | undefined;
  /** Larger value (the headline period, e.g. Today next to WTD). */
  big?: boolean;
  /** One highlighted line under the YoY (e.g. "Yesterday: 12.34 L"). */
  note?: React.ReactNode;
}

/** Two periods side by side (Today | WTD, WTD | MTD): value, vs LY and YoY for each. */
const KpiPanels: React.FC<{ panels: KpiPanel[] }> = ({ panels }) => (
  <div className="su-kpi-panels">
    {panels.map((p) => (
      <div key={p.label} className={`su-kpi-panel${p.big ? ' big' : ''}`}>
        <div className="su-kpi-panel-label">{p.label}</div>
        <div className="su-kpi-value su-num">
          {formatMoney(p.sales)}
          <span className="su-kpi-unit">{MONEY_UNIT.key}</span>
        </div>
        <div className="su-kpi-panel-sub su-num">vs LY {formatMoney(p.lySales)} {MONEY_UNIT.key}</div>
        <YoYBadge value={p.yoyPct} variant="inline" />
        {p.note != null && <div className="su-kpi-panel-note">{p.note}</div>}
      </div>
    ))}
  </div>
);

export default KpiPanels;
